import { BODY_PARTS, equipmentOptions, filterExercises, groupByLetter, type BodyPart, type Exercise, type ExerciseFilter } from "../core/exercises";
import { t } from "./texts";

/** Tab Übungen: alphabetical list with search and filters by equipment and body part. */
export function ExercisesTab(props: {
  exercises: Exercise[];
  filter: ExerciseFilter;
  onFilter(f: ExerciseFilter): void;
  onOpen(id: string): void;
  onCreate(): void;
}) {
  const { exercises, filter, onFilter } = props;
  const groups = groupByLetter(filterExercises(exercises, filter));
  const anyHidden = exercises.some((e) => e.hidden);

  return (
    <>
      <header className="titlebar">
        <h1>{t.exercises.title}</h1>
        <button className="primary" onClick={props.onCreate}>{t.exercises.add}</button>
      </header>
      <div className="sticky-filters">
        <input type="search" className="field" placeholder={t.exercises.search} value={filter.query ?? ""}
          onChange={(e) => onFilter({ ...filter, query: e.target.value })} />
        <div className="row">
          <select className="field" aria-label={t.exercises.filterEquipment} value={filter.equipment ?? ""}
            onChange={(e) => onFilter({ ...filter, equipment: e.target.value || undefined })}>
            <option value="">{t.exercises.filterEquipment}</option>
            {equipmentOptions(exercises).map((k) => <option key={k} value={k}>{t.equipment(k)}</option>)}
          </select>
          <select className="field" aria-label={t.exercises.filterBodyPart} value={filter.bodyPart ?? ""}
            onChange={(e) => onFilter({ ...filter, bodyPart: (e.target.value || undefined) as BodyPart | undefined })}>
            <option value="">{t.exercises.filterBodyPart}</option>
            {BODY_PARTS.map((k) => <option key={k} value={k}>{t.bodyPart(k)}</option>)}
          </select>
        </div>
      </div>

      {groups.length === 0 && <p className="muted-text">{t.exercises.none}</p>}
      {groups.map((g) => (
        <section key={g.letter}>
          <h2 className="letter">{g.letter}</h2>
          <ul className="list">
            {g.items.map((e) => (
              <li key={e.id}>
                <button className="list-item" onClick={() => props.onOpen(e.id)}>
                  <span className="name">{e.name}{e.hidden && <span className="badge">{t.exercises.hiddenBadge}</span>}</span>
                  <span className="sub">{t.equipment(e.equipment)} · {t.bodyPart(e.bodyPart)} · {t.measure(e.measure)}</span>
                </button>
              </li>
            ))}
          </ul>
        </section>
      ))}

      {anyHidden && (
        <button className="secondary wide" onClick={() => onFilter({ ...filter, hidden: !filter.hidden })}>
          {filter.hidden ? t.exercises.hideHidden : t.exercises.showHidden}
        </button>
      )}
    </>
  );
}
